<template>
  <div>
    <intent
      :showDefault="true"
      :total_count.sync="total_count"
      :all_count.sync="all_count"
      v-if="!reload"
      :isConversation="true"
    >
      <template slot="header">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <h1>
              {{ $t('Conversation') }}
              <a href="https://tinyurl.com/3758bkbm" target="blank"
                ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
              ></a>
            </h1>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-left text-sm-right">
            <v-btn
              depressed
              color="primary"
              v-if="selectedBot.pagetype != 'enterprise' && selectedBot.unlock_presets == true"
              @click="$router.push({ name: 'Upgrade', hash: '#selectchatbottemplate' })"
            >
              {{ $t('Select a chatbot template') }}
            </v-btn>
            <template>
              <chat-gpt-recommend @goto="goto" type="conversation" :intents="intents">
              </chat-gpt-recommend>
              <template-intent @goto="goto" type="conversation" :intents="intents">
              </template-intent>
            </template>
            <template>
              <transfer-intent
                type="conversation"
                :total_count.sync="total_count"
                :all_count.sync="all_count"
                :intents="intents"
              ></transfer-intent>
            </template>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 sm8>
            <p style="display: inline-block">
              {{ $t('To let your Chatbot being more accurate, add more conversation') }}
            </p>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-left text-sm-right px-2 pb-3">
            <a target="_blank" href="https://tinyurl.com/yc2hsp9x">
              <strong>*** {{ $t('Why my bot is not answer?') }}</strong>
            </a>
          </v-flex>
        </v-layout>
      </template>
    </intent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Intent from './Intent'
import TransferIntent from './TransferIntent'
import TemplateIntent from './TemplateIntent'
import ChatGptRecommend from './ChatGptRecommend'
export default {
  components: {
    Intent,
    TransferIntent,
    TemplateIntent,
    ChatGptRecommend
  },
  data() {
    return {
      all_count: 0,
      total_count: 0,
      from: '',
      reload: false
      // intents: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
      // loading: 'getLoadingIntents'
    }),
    intents() {
      return this.$store.getters.getIntents()
    },
    dialog() {
      // return this.from == 'Setup'
      return false
    }
  },
  methods: {
    goto(refName) {
      let vm = this
      vm.reload = true
      vm.$nextTick(() => {
        vm.reload = false
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.name
    })
  },
  async mounted() {
    // await this.$store.dispatch('loadIntent')
  },

  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Conversation.vue